import { useQuery } from '@hooks/reactQuery';

import { getGroups, getSeverities } from '@api/common';

import { optionsFormatted } from '@utils/formatter';

import { IAlarmByVendorFilter, IAlarmFilter } from '@interfaces/alarms/alarm';
import { TNameTitle } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';
import { TSelectOptionType } from '@components/common/Select/Select.types';

import { EVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { ALARM_GROUPS, ALARM_SEVERITIES } from '@constants/queryKeys';
import {
	statusAlarmManagementStringOptions,
} from '@components/routes/AdminPanel/AlarmManagement/AlarmManagementByVendor/constants';

export const useQueryLimenetAlarmFilters = (vendor: string): IAlarmByVendorFilter => {
	const isEnabled = vendor === EVendorsValues.limenet;

	const {
		data: groups,
		isInitialLoading: isLoadingGroups,
	} = useQuery<Array<TNameTitle>, TSelectOptionType<string>[]>({
		queryKey: [ALARM_GROUPS],
		queryFn: getGroups,
		select: (groups) => optionsFormatted<TNameTitle>(groups),
		...refetchOptions,
	});

	const {
		data: severities,
		isInitialLoading: isLoadedSeverities,
	} = useQuery<Array<TNameTitle>, TSelectOption<string>[]>({
		queryKey: [ALARM_SEVERITIES],
		queryFn: getSeverities,
		select: (severities) => optionsFormatted<TNameTitle>(severities),
		enabled: [isEnabled],
		...refetchOptions,
	});

	const limenetFilters: IAlarmFilter[] = isEnabled ? [
		{
			name: 'group',
			placeholder: 'Group',
			data: groups || [],
		},
		{
			name: 'severity',
			placeholder: 'Severity',
			data: severities || [],
		},
		{
			name: 'isActive',
			placeholder: 'Status',
			data: statusAlarmManagementStringOptions,
		},
	] : [];

	return {
		filters: limenetFilters,
		isLoading: isLoadingGroups || isLoadedSeverities,
	};
};
